<template>
  <div>
    <layout-vertical>

      <template>
        <div>
          <app-profile-alert
            v-if="isVerifyEmailLater && status && !isEmailVerified"
            class="mb-2"
          >
            <template #title>
              {{ $t('home.textToHelpYouRun') }} <span
                class="link text-success"
                @click="handleRequestVerifyEmail"
              >
                {{ $t('common.linkClickHere') }}
              </span> {{ $t('home.textToVerifyYourEmail') }}
            </template>
          </app-profile-alert>
          <div v-if="showStepGuide">
<!-- v-if="isShowBanner" -->
            <BannerHeader
              v-if="false"
              :banner-info="bannerInfo"
              class="mb-2"
            />

            <b-row>
              <b-col
                md="5"
                lg="3"
                class="d-none d-md-block"
              >
                <setup-guide-control />
                <list-event-slide
                  v-if="false"
                  class="mt-2"
                />
              </b-col>
              <b-col
                cols="12"
                class="d-md-none"
              >
                <setup-guide-mobile />
              </b-col>
              <b-col
                md="7"
                :lg="isTabRefundHistory ? '9' : '6'"
                cols="12"
                class="step-view"
              >
                <user-guide v-if="showUserGuide && ($device.mobile || $device.ipad)" />

                <router-view />

                <list-event-slide
                  v-if="false"
                  class="mt-2 d-md-none"
                />
              </b-col>

              <b-col
                v-if="!isTabRefundHistory && !$device.mobile && !$device.ipad"
                lg="3"
                class="position-sticky user-guide-container"
              >
                <user-guide v-if="showUserGuide" />
              </b-col>
            </b-row>
          </div>
          <div v-else>
            <router-view />
          </div>
        </div>
      </template>
      <template #navbar="{ toggleVerticalMenuActive }">
        <navbar
          v-if="isAuthenticated"
          :toggle-vertical-menu-active="toggleVerticalMenuActive"
        />
        <div v-else />
      </template>

    <!--    <app-customizer-->
    <!--      v-if="showCustomizer"-->
    <!--      slot="customizer"-->
    <!--    />-->
    </layout-vertical>
    <adreach-survey-modal
      ref="open-modal-adreach-survey"
      :user-info="userInfo"
    />
    <send-email-success-modal ref="verifyEmailRef" />

    <top-up-fail-modal
      ref="open-top-up-fail-modal"
      :error-message="rejectedReason"
    />
    <top-up-success-modal
      ref="open-top-up-success-modal"
    />

    <service-fee-upgrade-modal
      :show="showModalServiceFee"
      @close-modal="onCloseModalServiceFee"
    />
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
import { $themeConfig } from '@themeConfig'
import SetupGuideMobile from '@/components/setup-guide-component/SetupGuideMobile.vue'
import SetupGuideControl from '@/components/setup-guide-component/SetupGuideControl.vue'
import ListEventSlide from '@/views/home/components/ListEventSlide.vue'
import stepGuideMixin from '@/mixins/stepGuideMixin'
import AppProfileAlert from '@core/components/app-alert-top-bar/AppProfileAlert.vue'
import { createNamespacedHelpers } from 'vuex'
import { toastification } from '@core/mixins/toast'
import SendEmailSuccessModal from '@core/components/app-alert-top-bar/SendEmailSuccessModal.vue'
import AdreachSurveyModal from '@/views/home/components/AdreachSurveyModal.vue'
import ServiceFeeUpgradeModal from '@/components/ServiceFeeUpgradeModal.vue'
import _get from 'lodash/get'
import _isEmpty from 'lodash/isEmpty'
import envMixin from '@/mixins/envMixin'
import UserGuide from '@/components/UserGuide.vue'
import { PAYMENT_METHOD, TICKET_TYPE, ONBOARDING_STEP } from '@/constants'
import TopUpFailModal from '@/views/payment/components/LocalBank/TopUpFailModal.vue'
import TopUpSuccessModal from '@/views/payment/components/LocalBank/TopUpSuccessModal.vue'
import BannerHeader from '@/views/home/components/BannerHeader.vue'
import Navbar from '../components/Navbar.vue'

const { mapGetters, mapActions } = createNamespacedHelpers('auth')
const { mapGetters: mapPaymentGetters, mapActions: mapPaymentActions } = createNamespacedHelpers('payment')
export default {
  components: {
    BannerHeader,
    TopUpSuccessModal,
    TopUpFailModal,
    SendEmailSuccessModal,
    AppProfileAlert,
    // AppCustomizer,
    LayoutVertical,
    Navbar,
    SetupGuideControl,
    SetupGuideMobile,
    ListEventSlide,
    AdreachSurveyModal,
    UserGuide,

    BRow,
    BCol,
    ServiceFeeUpgradeModal,
  },

  mixins: [stepGuideMixin, toastification, envMixin],

  data() {
    return {
      showCustomizer: $themeConfig.layout.customizer,
      isTabRefundHistory: false,
      linkDetail: 'https://ecomdycom.larksuite.com/docx/NA9LdCbBNo2IQFxXCkluRequsGe',

      showServiceFeeModal: false,

      rejectedReason: '',

      bannerInfo: {
        desktop: {
          imgUrl: 'https://files.ecomdy.com/images/f2f59330-7e14-40c2-8013-af0e1a6edd41-1764830847885.jpeg',
          url: 'https://ecomdycom.sg.larksuite.com/docx/PRg3dfXKbohGD6xCHDNlMdvFggb',
        },
        laptop: {
          imgUrl: 'https://files.ecomdy.com/images/d4c49b53-8b46-4486-ab97-c246a8ce2524-1764830888433.jpeg',
          url: 'https://ecomdycom.sg.larksuite.com/docx/PRg3dfXKbohGD6xCHDNlMdvFggb',
        },
        tablet: {
          imgUrl: 'https://files.ecomdy.com/images/c2ed233a-9cf5-426d-b8dc-97e8a1d26c72-1764830903757.jpeg',
          url: 'https://ecomdycom.sg.larksuite.com/docx/PRg3dfXKbohGD6xCHDNlMdvFggb',
        },
        mobile: {
          imgUrl: 'https://files.ecomdy.com/images/1a0b1ba4-ac56-4106-8f24-f71607b6bf81-1764830917078.jpeg',
          url: 'https://ecomdycom.sg.larksuite.com/docx/PRg3dfXKbohGD6xCHDNlMdvFggb',
        },
      },
    }
  },

  computed: {
    ...mapGetters(['user', 'status', 'error', 'loading', 'message', 'isAuthenticated']),
    ...mapPaymentGetters(['listTicket', 'ticketDetail', 'ticketAuto']),
    isMember() {
      return !_isEmpty(this.user?.data?.belongToPartner)
    },
    showModalServiceFee() {
      if (_isEmpty(this.user?.data)) return false
      const currentStep = Number(this.setupGuideStep)
      const isAddFundRoute = this.$route?.name === 'add-fund'
      if (currentStep && currentStep < ONBOARDING_STEP.USING_OFFICIAL_ADS_ACCOUNT) {
        if (currentStep < ONBOARDING_STEP.DEPOSITING_MONEY) return false
        if (currentStep > ONBOARDING_STEP.DEPOSITING_MONEY && !isAddFundRoute) return false
      }
      if (!this.showServiceFeeModal) return false
      if (this.isMember) return false
      if (!this.isAdSolutions) return false
      if (!['dashboard', 'payment', 'add-fund'].includes(this.$route?.name)) return false

      const stored = localStorage.getItem('show-fee-upgrade')
      if (stored) {
        try {
          const upgradeInfo = JSON.parse(stored)
          if (upgradeInfo && upgradeInfo.show === false) {
            return false
          }
          if (upgradeInfo && upgradeInfo.firstShown) {
            const firstShownDate = new Date(upgradeInfo.firstShown)
            const sevenDaysInMs = 7 * 24 * 60 * 60 * 1000
            if (new Date() - firstShownDate > sevenDaysInMs) {
              return false
            }
          }
        } catch (e) {
          // fallback
        }
      }
      return true
    },
    userInfo() {
      return _get(this.user, ['data'])
    },

    countryName() {
      return _get(this.user, ['data', 'signupTracking', 'countryName'], '')
    },

    isExpires() {
      return new Date() > new Date('2025-12-30T17:00:00.164Z')
    },

    showStepGuide() {
      const listPageNoNeedStepGuide = [
        'profile',
        'billing',
        'pricing',
        'referral-partner-info',
        'faq',
        'referral-introduce',
        'referral',
        'reactive-stripe',
        'affiliate-program',
      ]

      const currentPage = this.$route?.name
      const partnerPage = 'partner-management'
      const partnerInfoPage = 'partner-info-url'
      const memberPartnerPage = 'member'
      const pixelPageNames = [
        'pixel-management',
        'pixel-create',
        'pixel-detail',
      ]
      if (pixelPageNames?.includes(currentPage)) {
        return false
      }

      return this.hasStepGuide
        && !listPageNoNeedStepGuide?.includes(currentPage)
        && !currentPage?.includes(partnerPage)
        && !currentPage?.includes(memberPartnerPage)
        && !currentPage?.includes(partnerInfoPage)
    },
    isEmailVerified() {
      return this.user.data?.verifyEmailAt
    },
  },

  watch: {
    listTicket: {
      handler(val) {
        if (val && this.isShowUSDTAuto) {
          const itemDetail = val?.content?.find(
            item => item?.details?.paymentMethod === PAYMENT_METHOD.USDT
              && item.status === 'opening' && !!item?.details?.verificationId,
          )
          if (itemDetail) {
            this.getTicketAutoInfo(itemDetail)
          }
        }
      },
      deep: true,
      immediate: true,
    },

    ticketAuto: {
      handler(val) {
        if (val && this.isShowUSDTAuto) {
          if (val.status === 'opening') {
            this.getTicketAutoInfo(val)
          }
        }
      },
      deep: true,
      immediate: true,
    },

    generalConfigs: {
      handler() {
        /* Open if marketing need */
        this.isShowBanner = !!(this.countryName && this.countryName !== 'Vietnam' && !this.isExpires && this.isEcomdyPlatform)
      },
      deep: true,
      immediate: true,
    },

    $route: {
      handler(route) {
        if (route?.query?.tabActive === 'refund_history') {
          this.isTabRefundHistory = true
        } else {
          this.isTabRefundHistory = false
        }
      },
      deep: true,
      immediate: true,
    },

    user: {
      handler(userInfo) {
        if (!_isEmpty(userInfo?.data)) {
          const stored = localStorage.getItem('show-fee-upgrade')
          if (stored) {
            try {
              const upgradeInfo = JSON.parse(stored)
              if (upgradeInfo && upgradeInfo.show === false) {
                this.showServiceFeeModal = false
              } else {
                this.showServiceFeeModal = true
              }
            } catch (e) {
              this.showServiceFeeModal = true
            }
          } else {
            this.showServiceFeeModal = true
          }
        }

        if (this.userInfo && this.userInfo?.onboardingStep === 2 && localStorage.getItem('isDoneSurvey') !== 'true' && this.isAdreachPlatform) {
          this.openAdreachSurveyModal()
        }

        if (userInfo?.data?.localUserId && this.isShowUSDTAuto) {
          // USDT auto need check list ticket opening => call this API
          this.fetchListTicketPending()
        }
      },
      deep: true,
      immediate: true,
    },

    showModalServiceFee: {
      handler(val) {
        const stored = localStorage.getItem('show-fee-upgrade')
        let upgradeInfo = {}
        if (stored) {
          try {
            upgradeInfo = JSON.parse(stored)
            if (upgradeInfo && upgradeInfo.firstShown) {
              const firstShownDate = new Date(upgradeInfo.firstShown)
              const sevenDaysInMs = 7 * 24 * 60 * 60 * 1000
              if (new Date() - firstShownDate > sevenDaysInMs) {
                upgradeInfo.show = false
                localStorage.setItem('show-fee-upgrade', JSON.stringify(upgradeInfo))
              }
            }
          } catch (e) {
            // fallback
          }
        }
        if (val) {
          if (!upgradeInfo.firstShown) {
            upgradeInfo.firstShown = new Date().toISOString()
            upgradeInfo.show = true
            localStorage.setItem('show-fee-upgrade', JSON.stringify(upgradeInfo))
          }
        }
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions(['requestVerifyEmail', 'getAccountInfo']),
    ...mapPaymentActions(['getListTicket', 'getTicketDetail']),
    getTicketAutoInfo(itemDetail) {
      const intervalActive = setInterval(async () => {
        // eslint-disable-next-line no-underscore-dangle
        await this.getTicketDetail(itemDetail._id)
        if (this.ticketDetail && !this.details?.autoUSDTRejectedReason) {
          clearInterval(intervalActive)
        }
        if (this.ticketDetail && this.ticketDetail.status === 'rejected') {
          this.rejectedReason = this.ticketDetail.rejectedReason || ''
          this.$refs['open-top-up-fail-modal'].showModal()
          clearInterval(intervalActive)
          this.fetchListTicketPending()
        }
        if (this.ticketDetail && this.ticketDetail.status === 'approved') {
          this.$refs['open-top-up-success-modal'].showModal()
          clearInterval(intervalActive)
          this.getAccountInfo()
          this.fetchListTicketPending()
        }
      }, 5000)
    },

    onCloseModalServiceFee() {
      this.showServiceFeeModal = false
      const stored = localStorage.getItem('show-fee-upgrade')
      let upgradeInfo = {}
      if (stored) {
        try {
          upgradeInfo = JSON.parse(stored)
        } catch (e) {
          // fallback
        }
      }
      upgradeInfo.show = false
      localStorage.setItem('show-fee-upgrade', JSON.stringify(upgradeInfo))
    },

    async fetchListTicketPending() {
      const params = {
        type: TICKET_TYPE.RECHARGE_USER_BALANCE,
        status: ['opening'],
      }
      await this.getListTicket({ params })
    },

    async handleRequestVerifyEmail() {
      if (this.loading) return

      await this.requestVerifyEmail()

      if (this.status) {
        this.$refs.verifyEmailRef.showModal()
      } else {
        this.toastFailure(this.message)
      }
    },

    openAdreachSurveyModal() {
      this.$refs['open-modal-adreach-survey'].showModal()
    },
  },
}
</script>

<style lang="scss" scoped>
  .link{
    text-decoration: underline;
    cursor: pointer;
  }

  .user-guide-container {
    height: max-content;
    top: 24px;
  }

  .notification-refund-policy {
    cursor: pointer;
    background: rgba(38, 103, 255, 0.1) !important;

    .title-notification {
      margin-bottom: .5rem;

      display: flex;
      align-items: center;

      .ic-docs {
        margin-right: 5px;
      }

      .ic-notification {
        margin-left: 6px;
        color: #2667ff;
      }
    }
  }

  .ic-lightbulb {
    background-color: var(--icon-document-color);
    border-radius: 50%;
    width: 20px;
    height: 20px;
  }
</style>
